export default {
    last_scroll: 0,
    scroll_distance: 0,
    init() {
        window.addEventListener('scroll', this.stickyMenu)
    },
    stickyMenu() {

        let header = document.getElementById('header');
        let sticky_header = document.getElementById('sticky-header');

        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        var nav = document.getElementById('header');

        const scroll_required = 350;

        if(header && sticky_header) {
            //if we are scrolling up
            if(scrollTop < this.last_scroll) {
                // scrollTop += 
                this.scroll_distance += this.last_scroll - scrollTop
            }
            //else we are scroll down so refresh the scroll distance
            else {
                this.scroll_distance = 0;
            }

            //if we are a decent way down the page and we are not scrolling up.
            // if(scrollTop > scroll_required && this.scroll_distance < 200) {
            if(scrollTop > scroll_required) {
                // console.log('PAST HEADER')
                // nav.classList.add('header--sticky');
                header.classList.add('header--hide')
                sticky_header.classList.add('sticky-header--visible')
            } else {
                sticky_header.classList.remove('sticky-header--visible')
                nav.classList.remove('header--hide')
            }
        }

        this.last_scroll = scrollTop;

    }
}